import Cookies from 'js-cookie';

import { getDomainForCookies } from './getDomainForCookies';

export const cookies = Cookies.withAttributes({ domain: getDomainForCookies(window.location.hostname), path: '/' });
